
export const SELLER_SIGNIN_REQUEST = 'SELLER_SIGNIN_REQUEST';
export const SELLER_SIGNIN_SUCCESS = 'SELLER_SIGNIN_SUCCESS';
export const SELLER_SIGNIN_FAIL = 'SELLER_SIGNIN_FAIL';

export const SELLER_REGISTER_REQUEST = 'SELLER_REGISTER_REQUEST';
export const SELLER_REGISTER_SUCCESS = 'SELLER_REGISTER_SUCCESS';
export const SELLER_REGISTER_FAIL = 'SELLER_REGISTER_FAIL'; 